module.exports = __webpack_public_path__ + "img/Faisal_Masjid_Islamabad.eaab66ab.jpg";